import React, { Component } from 'react';
import './SatusAll.scss';
import { statuses, base } from '../../../../config'
import { objCleaner } from '../../../helpers'
import * as _ from 'lodash'
import Job from '../../../components/Job'

class StatusAll extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    };

    _delete (sheetId) {
      console.log(sheetId);
      const _this = this
      base.remove(`user_details/${this.props.uid}/sheets/${sheetId}`, (err) => {
        console.log(err);
      })
      base.remove(`user_details/${this.props.uid}/jobs/${sheetId}`, (err) => {
        console.log(err);
      })
    }

    render() {

      const sheets = this.props.jobs.map((item) => {
        return (
          <div className='col-sm-3'>
            <Job class="colf" delete={this._delete} key={`${item.key}`} id={`${item.key}`} uid={this.props.uid} job={item} />
          </div>
        )
      })

        return (
            <div className='satus-all'>
                <h4 className='m-t-0 m-b-lg'>All Jobs</h4>
                <div className="row">
                  {sheets}
                </div>
            </div>
        )
    }
}

export default StatusAll;



// WEBPACK FOOTER //
// ./src/views/pages/Jobs/StatusAll/index.js